export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8969.ebf134f6.jpg";